const O = 6, e = -1;
var t = /* @__PURE__ */ ((o) => (o.Floating = "floating", o.Fixed = "fixed", o))(t || {});
export {
  e as NO_ACTIVE_OPTION,
  O as OPTIONS_MAX_LENGTH,
  t as VariantsEnum
};
